// @flow
import { useCallback } from 'react';

import FilterSection from '../catalogFilters/FilterSection';
import FilterTab from '../catalogFilters/FilterTab';
import FilterCheckItem from '../catalogFilters/FilterCheckItem';
import FilterItems from '../catalogFilters/FilterCheckItems';

import css from '@styles/ringFilters';

type TProps = {
  filters: Array<string>,
  isOpen: boolean,
  onToggle: () => void
};

const whiteIcon = '/images/metal-color-icons/white.png';
const yellowIcon = '/images/metal-color-icons/yellow.png';
const roseIcon = '/images/metal-color-icons/rose.png';
const twoToneIcon = '/images/metal-color-icons/two-tone.png';

function itemIsSelected (selectedItems, item) {
  return selectedItems.indexOf(item) >= 0;
}

export default function MetalFilters ({
  filters,
  onFilterCheckToggle,
  selectedItems,
  isOpen,
  onToggle
}) {
  const handleCheckToggle = useCallback((e) => {
    onFilterCheckToggle('metal', e.currentTarget.value);
  }, []);

  return (
    <FilterSection
      className={css.metal}
      enableClickOutside={isOpen}
      onClickOutside={onToggle}>
      <FilterTab
        name="Metal"
        className={css.metalTab}
        showingContent={isOpen}
        activeFilterCount={selectedItems.length}
        onClick={onToggle}
        key="metal-tab"
      />
      <FilterItems
        className={css.metalContent}
        show={isOpen}
        key="metal-content">
        <FilterCheckItem
          label="Platinum"
          inputValue="PLAT"
          htmlId="metal-plat"
          image={whiteIcon}
          imageAlt="example"
          selected={itemIsSelected(selectedItems, 'PLAT')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label="14K White Gold"
          inputValue="14KW"
          htmlId="metal-14kw"
          image={whiteIcon}
          imageAlt="example"
          selected={itemIsSelected(selectedItems, '14KW')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label="18K White Gold"
          inputValue="18KW"
          htmlId="metal-18kw"
          image={whiteIcon}
          imageAlt="example"
          selected={itemIsSelected(selectedItems, '18KW')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label="14K Yellow Gold"
          inputValue="14KY"
          htmlId="metal-14ky"
          image={yellowIcon}
          imageAlt="example"
          selected={itemIsSelected(selectedItems, '14KY')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label="18K Yellow Gold"
          inputValue="18KY"
          htmlId="metal-18ky"
          image={yellowIcon}
          imageAlt="example"
          selected={itemIsSelected(selectedItems, '18KY')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label="14K Rose Gold"
          inputValue="14KR"
          htmlId="metal-14kr"
          image={roseIcon}
          imageAlt="example"
          selected={itemIsSelected(selectedItems, '14KR')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label="18K Rose Gold"
          inputValue="18KR"
          htmlId="metal-18kr"
          image={roseIcon}
          imageAlt="example"
          selected={itemIsSelected(selectedItems, '18KR')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label="Two Tone"
          inputValue="Two Tone"
          htmlId="metal-two-tone"
          image={twoToneIcon}
          imageAlt="example"
          selected={itemIsSelected(selectedItems, 'Two Tone')}
          onChange={handleCheckToggle}
        />
      </FilterItems>
    </FilterSection>
  );
}
